import { useQuery } from "react-query";
import { SusunanKeluargaResponse } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const allSusunanKeluargaKey = "all-susunan-keluarga-key";

export async function allSusunanKeluarga(): Promise<SusunanKeluargaResponse[]> {
  const res = await ApiClient.get(`/AllKeluarga`);
  return res.data;
}

export default function useFetchAllSusunanKeluarga() {
  return useQuery([allSusunanKeluargaKey], queryWrapper(allSusunanKeluarga));
}
